import { cancelledUnpaid } from '@/constant'

// «З» открытого занятия заменяется общим статусом; персональный отчёт сохраняется.
export const resolveInitialStudentStatus = (row, lessonStatus, currentLessonStatus, isOpenLesson = false) => {
  if (row.joined_after_lesson) return row.status ?? null
  if (
    lessonStatus === '5' && row.status != null &&
    (!isOpenLesson || Number(row.status) !== 6) &&
    (isOpenLesson || ![10, 11, 12].includes(Number(currentLessonStatus)))
  ) {
    return row.status
  }
  return lessonStatus
}

export const getLessonStatusOptions = ({
  conferenceType,
  directionTariff,
  hasPaidCancel,
  canRescheduleCurrentReport,
  isOpen,
  isClosedCustomizable,
  hasOpenLessonAttendees = true,
}) => {
  if (isClosedCustomizable) {
    return [
      { label: 'Проведено', value: '5' },
      { label: 'Перенесено занятие', value: 'reschedule' },
      { label: 'Отменено', value: '11' },
    ]
  }

  if (isOpen && !hasOpenLessonAttendees) {
    return [{ label: 'Отменено (педагог)', value: '11' }]
  }

  const nextOptions = [{ label: 'Проведено', value: '5' }]
  const isGroupPerLesson = directionTariff === 'group_per_lesson'

  if (canRescheduleCurrentReport) {
    nextOptions.push({ label: 'Перенесено занятие', value: 'reschedule' })
  }

  nextOptions.push({ label: 'Отменено (педагог)', value: '11' })

  if (isGroupPerLesson) {
    nextOptions.push({ label: 'Отменено (ученик)', value: '10' })
    nextOptions.push({ label: 'Платная отмена', value: '12' })
    return nextOptions
  }

  if (conferenceType === 'group') {
    nextOptions.push({ label: 'Отменено (ученик)', value: '10' })
    return nextOptions
  }

  if (conferenceType !== 'group') {
    nextOptions.push({ label: 'Отменено (ученик)', value: '10' })
    if (conferenceType !== 'introduction') {
      if (!isOpen) {
        nextOptions.push({
          label: 'Отменено (не оплачено)',
          value: String(cancelledUnpaid),
        })
      }

      if (isOpen || Number(hasPaidCancel) === 1 || conferenceType === 'private') {
        const disabled = !isOpen && Number(hasPaidCancel) !== 1
        nextOptions.push({
          label: 'Платная отмена', value: '12',
          ...(disabled ? { disabled: true, title: 'Зайдите в настройки тарифа и включите платную отмену' } : {}),
        })
      }
    }
  }

  return nextOptions
}

export const getLessonStatusDescription = (
  status,
  isClosedCustomizable = false,
) => {
  switch (status) {
    case '10':
      return 'Опишите причину отмены занятия (отмена учеником)'
    case '11':
      return isClosedCustomizable
        ? 'Опишите причину отмены занятия'
        : 'Опишите причину отмены занятия (отмена педагогом)'
    case '12':
      return 'Опишите причину отмены занятия (платная отмена)'
    case 'reschedule':
      return 'Напишите комментарий (перенос занятия)'
    default:
      return 'Напишите комментарий'
  }
}

export const isClosedCustomizableLesson = (report) =>
  report?.conference_type === 'customizable' && String(report?.isOpen) === '0'

export const isLessonStatusCommentRequired = (status, conferenceType) =>
  status !== '5' || conferenceType === 'introduction'

export const shouldSaveLessonSalary = (
  canEditSalary,
  conferenceType,
  salaryChanged,
) => {
  void conferenceType
  return canEditSalary && salaryChanged
}
